// assets
import { IconDashboard } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
  id: 'dashboard',
  title: 'dashboard', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconDashboard,
  type: 'group',
  url: '/dashboard'
};

export default dashboard;
